<template>
  <i-rack class="pa-0" column>
    <i-section :scrollable="false">
      <iframe src="https://amgen.showcase-app.io/#/auth/login" class="showcase-frame" />
    </i-section>
  </i-rack>
</template>

<script>
import HeaderView from '../components/core/header/HeaderView';
export default {
  name: 'ShowcaseContainer'
};
</script>

<style scoped>
.showcase-frame {
  width: 100%;
  height: 100%;
  border: 0px;
  outline: 0;
}
</style>
